// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

// @flow
import axios from 'axios'
import {APIUrl, APIHeaders} from './utils'
import {UAI_API} from '../config'
import {stopSubmit, setSubmitSucceeded, setSubmitFailed, startSubmit} from 'redux-form'
import {showComponentSpinner, ON_SAVE, ON_DELETE} from './spinner'
import {unexpectedApiError} from './apiErrors'
import {errorToast, successToast} from './toastMessages'
import {showAddForm, showEditForm} from './table'
import {loginWithoutPassword} from './user'

export const FETCH_USERS = 'fetch_users'

export function addUser (values) {
  return (dispatch, getState) => {
    const {session} = getState()
    const usersFullName = `${values.firstName} ${values.lastName}`
    dispatch(startSubmit('addUserTableFrom'))
    dispatch(showComponentSpinner(true))

    const updated_values = {
      firstName: values.firstName,
      lastName: values.lastName,
      role: values.role.value || values.role
    }

    const emailDomain = session.user_data.email.split('@')[1]

    return axios.put(APIUrl(`user/${values.userName}@${emailDomain}`, {}, UAI_API), updated_values, {headers: APIHeaders(session)}).then(() => {
      dispatch(successToast(`${usersFullName} User has been added successfully`, 'alert-success'))
      dispatch(showAddForm())
      dispatch(stopSubmit('addUserTableFrom'))
      dispatch(setSubmitSucceeded('addUserTableFrom'))
      dispatch(showComponentSpinner(false))
      dispatch(fetchUsers())
    }).catch((error) => {
      dispatch(setSubmitFailed('addUserTableFrom'))
      dispatch(showComponentSpinner(false))
      dispatch(stopSubmit('addUserTableFrom'))
      if (error.response) {
        dispatch(errorToast(error.response.data.message))
      } else {
        dispatch(unexpectedApiError())
      }
    })
  }
}

export function deleteUser (userName, firstName, lastName) {
  return (dispatch, getState) => {
    const {session} = getState()
    const usersFullName = `${firstName} ${lastName}`
    dispatch(showComponentSpinner(true, ON_DELETE))

    // TODO: You can not delete yourself!

    return axios.delete(APIUrl(`user/${userName}`, {}, UAI_API), {headers: APIHeaders(session)}).then(() => {
      dispatch(showEditForm(0))
      dispatch(showComponentSpinner(false))
      dispatch(successToast(`${usersFullName} has been removed successfully`))
      dispatch(fetchUsers())
    }).catch((error) => {
      dispatch(showComponentSpinner(false))
      if (error.response) {
        dispatch(errorToast(error.response.data.message))
      } else {
        dispatch(unexpectedApiError())
      }
    })
  }
}

export function fetchUsers () {
  return async (dispatch, getState) => {
    const {session} = getState()
    try {
      dispatch(showComponentSpinner(true))
      const resp = await axios.get(APIUrl(`user/`, {}, UAI_API), {headers: APIHeaders(session)})
      dispatch({
        type: FETCH_USERS,
        payload: {
          users: resp.data.data
        }
      })
      dispatch(showComponentSpinner(false))
    } catch (error) {
      dispatch(errorToast(`Failed to get all users`))
      dispatch(showComponentSpinner(false))
    }
  }
}

export function updateMyProfile (values) {
  return (dispatch, getState) => {
    const {session} = getState()
    const usersFullName = `${values.firstName} ${values.lastName}`

    dispatch(startSubmit('MyPersonalInfo'))

    const updated_values = {
      firstName: values.firstName,
      lastName: values.lastName,
      role: values.role
    }

    return axios.patch(APIUrl(`user/${values.username}`, {}, UAI_API), updated_values, {headers: APIHeaders(session)}).then(() => {
      dispatch(stopSubmit('MyPersonalInfo'))
      dispatch(setSubmitSucceeded('MyPersonalInfo'))

      dispatch(loginWithoutPassword())
      dispatch(successToast(`${usersFullName} has been updated successfully.`))

    }).catch(() => {
      dispatch(stopSubmit('MyPersonalInfo'))
      dispatch(setSubmitSucceeded('MyPersonalInfo'))
      dispatch(errorToast(`Failed to update ${usersFullName}.`))
    })
  }
}

export function updateUser (values, form = 'updateUserTableFrom') {
  return (dispatch, getState) => {
    const {session} = getState()
    const usersFullName = `${values.firstName} ${values.lastName}`
    dispatch(startSubmit(form))
    dispatch(showComponentSpinner(true, ON_SAVE))

    const updated_values = {
      firstName: values.firstName,
      lastName: values.lastName,
      role: values.role.value
    }

    return axios.patch(APIUrl(`user/${values.userName}`, {}, UAI_API), updated_values, {headers: APIHeaders(session)}).then(() => {
      dispatch(showComponentSpinner(false))
      dispatch(stopSubmit(form))
      dispatch(setSubmitSucceeded(form))
      dispatch(showEditForm(0))
      dispatch(fetchUsers())
      dispatch(successToast(`${usersFullName} has been updated successfully.`))

    }).catch(() => {
      dispatch(showComponentSpinner(false))
      dispatch(stopSubmit('updateUserTableFrom'))
      dispatch(setSubmitSucceeded('updateUserTableFrom'))
      dispatch(errorToast(`Failed to update ${usersFullName}.`))
    })
  }
}

export function updateUserProducts (values) {
  // This function is fully mocked
  return (dispatch, getState) => {
    const {userManagement} = getState()
    dispatch(startSubmit('updateUserTableFrom'))
    dispatch(showComponentSpinner(true))
    let {users} = userManagement
    for (let user in users) {
      if (users[user].userName === values.userName) {
        let products = users[user].products || {}
        for (let key in values) {
          if (key !== 'userName') {
            products[key] = values[key]
          }
        }
        users[user].products = products
      }
    }
    dispatch(showComponentSpinner(false))
    dispatch(stopSubmit('updateUserTableFrom'))
    dispatch(setSubmitSucceeded('updateUserTableFrom'))
  }
}
